interface SalonDestination {
  id: string;
  title: string;
  googleMapsUrl: string;
  coordinates: {
    lat: number;
    lng: number;
  };
}

export const salonDestinations: Record<string, SalonDestination> = {
  villejuif: {
    id: "villejuif",
    title: "Salon de Villejuif",
    googleMapsUrl: "https://maps.app.goo.gl/VgeQQEUz2StghyAm7",
    coordinates: {
      lat: 48.793904892424955,
      lng: 2.3667598143077564,
    },
  },
  "ville-davray": {
    id: "ville-davray",
    title: "Salon de Ville d'Avray",
    googleMapsUrl: "https://maps.app.goo.gl/ejJVzmBh5UXsAtaL9",
    coordinates: {
      lat: 48.82852616031252,
      lng: 2.190979341300038,
    },
  },
  "au-grey-des-couleurs": {
    id: "au-grey-des-couleurs",
    title: "Salon Au Grey des Couleurs",
    googleMapsUrl: "https://maps.app.goo.gl/sLUwBduUuxNqP8ej6",
    coordinates: {
      lat: 48.794830396400094,
      lng: 2.3631880701334005,
    },
  },
};
